/* eslint-disable */

/** unique or primary key constraints on table "argo.link" */
export enum ArgoLinkConstraint {
  /** unique or primary key constraint on columns "context_id", "group_name", "name" */
  LinkContextIdGroupNameNameKey = 'link_context_id_group_name_name_key',
  /** unique or primary key constraint on columns "link_id" */
  LinkPkey = 'link_pkey'
}

/** select columns of table "argo.link" */
export enum ArgoLinkSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Shared = 'shared',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** update columns of table "argo.link" */
export enum ArgoLinkUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Shared = 'shared',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

